import { render, staticRenderFns } from "./statusTabs.vue?vue&type=template&id=5b0b9574&scoped=true"
import script from "./statusTabs.vue?vue&type=script&lang=js"
export * from "./statusTabs.vue?vue&type=script&lang=js"
import style0 from "./statusTabs.vue?vue&type=style&index=0&id=5b0b9574&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0b9574",
  null
  
)

export default component.exports